export default "__VITE_ASSET__DedsWxCt__"